import React from 'react'
import { appSpacing } from '../Styles'

const Spacer = ({ size = appSpacing, double, half }) =>
  <div style={{ margin: double ? size * 3 : half ? size / 2 : size }} />

export default Spacer